export default (paymentMethod) => {
  if (paymentMethod === 'GOOGLE_PAY') return 'google pay';
  if (paymentMethod === 'APPLE_PAY') return 'apple pay';
  if (paymentMethod === 'CARD') return 'card';

  return paymentMethod;
};
